<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- Filter search -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="Icon URL" prop="iconUrl">
                <a-input v-model="queryParam.iconUrl" placeholder="Please enter icon URL" allow-clear/>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="Infrastructure Name" prop="title">
                <a-input v-model="queryParam.title" placeholder="Please enter infrastructure name" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!-- <a-col :md="8" :sm="24">
                <a-form-item label="Enabled 0-No 1-Yes" prop="isOpen">
                  <a-input v-model="queryParam.isOpen" placeholder="Enter enabled 0-No 1-Yes" allow-clear/>
                </a-form-item>
              </a-col> -->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? 'Collapse' : 'Expand' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- Toolbar -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['golf:infrastructure:add']">
          <a-icon type="plus" />Add
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['golf:infrastructure:edit']">-->
<!--          <a-icon type="edit" />Edit-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['golf:infrastructure:remove']">-->
<!--          <a-icon type="delete" />Delete-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['golf:infrastructure:export']">-->
<!--          <a-icon type="download" />Export-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="iconUrl" slot-scope="text">
          <img
            v-if="text"
            class="infra-table-icon"
            v-image-preview
            :src="text"
            alt=""
          />
          <span v-else>—</span>
        </span>
        <span slot="isOpen" slot-scope="text">
          {{ formatIsOpen(text) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['golf:infrastructure:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['golf:infrastructure:edit']">
            <a-icon type="edit" />Edit
          </a>
          <a-divider type="vertical" v-hasPermi="['golf:infrastructure:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['golf:infrastructure:remove']">
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageInfrastructure, delInfrastructure } from '@/api/golf/infrastructure'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Infrastructure',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        iconUrl: null,
        title: null,
        isOpen: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Icon',
          dataIndex: 'iconUrl',
          width: 96,
          scopedSlots: { customRender: 'iconUrl' },
          align: 'center'
        },
        {
          title: 'Infrastructure Name',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Enabled',
          dataIndex: 'isOpen',
          scopedSlots: { customRender: 'isOpen' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Actions',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    formatIsOpen (val) {
      if (val === 0 || val === '0') {
        return 'No'
      }
      if (val === 1 || val === '1') {
        return 'Yes'
      }
      return '—'
    },
    getList () {
      this.loading = true
      pageInfrastructure(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        iconUrl: undefined,
        title: undefined,
        isOpen: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm deletion of selected data?',
        content: 'Selected IDs: ' + ids,
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delInfrastructure(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Confirm export?',
        content: 'This will export all data under current filters, not just selected rows.',
        onOk () {
          that.download('golf/golf-infrastructure/export', {
            ...that.queryParam
          }, `infrastructure_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.infra-table-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  vertical-align: middle;
  cursor: pointer;
}
</style>
